(ns dre.components.search-results.views
  (:require
   ["antd" :refer [Spin]]
   [dre.app.events :as-alias app]
   [dre.components.searchbar.main-searchbar :refer [main-searchbar]]
   [dre.components.search-results.events :as-alias results]
   [dre.components.search-results.views.article :as article]
   [dre.components.search-results.views.header :as header]
   [dre.components.search-results.views.footer :as footer]
   [dre.components.widget.views.common :refer [no-result]]
   [dre.widgets.question-answering.events :as-alias qa-events]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]))


(def component-name :search-results)


(defn listing
  [state user]
  (let [articles (:articles state)
        grouped-articles (group-by :group articles)]
    (if articles
      [:<>
       (for [[idx item] (map-indexed vector articles)
             :let [idx (inc idx)]]
         ^{:key idx}
         [article/view (assoc item :index idx) (> (count (get grouped-articles (:group item))) 1) state user])]
      [no-result true])))


(defn view
  []
  (let [state @(rf/subscribe [::results/state])
        user @(rf/subscribe [::app/user])
        loading? (or (= :loading (:state state))
                     (and (= :ai-sum (:order state))
                          (or 
                           (not (nil? (:stream-id @(rf/subscribe [::qa-events/state]))))
                           (= :loading (:state @(rf/subscribe [::qa-events/state]))))))
        show-boost? @(rf/subscribe [::results/show-boost-searchbar?])]
    [:div
     {:class [component-name "widget"]}
     [:div
      {:class [(bem/be component-name :header)]}
      [header/view state user]
      (when show-boost?
        [:div
         {:class :boost-searchbar}
         [main-searchbar
          {:db-root-path [:boost-query]}
          {:on-submit #(rf/dispatch [::results/fetch nil (:last-seen state)])
           :show-optimize-button? false
           :show-hint? (constantly false)
           :show-filters? false}]])]
     (if loading?
       [:> Spin
        [:div
         {:class (bem/be component-name :listing)}
         [listing state user]]]
       [:div
        {:class (bem/be component-name :listing)}
        [listing state user]])
     [:div
      {:class [(bem/be component-name :footer) "widget-rgl-footer"]}
      [footer/view state]]
     [:div {:class ["widget-rgl-header" "widget-rgl-top"]}]
     [:div {:class ["widget-rgl-header" "widget-rgl-bottom"]}]
     [:div {:class ["widget-rgl-header" "widget-rgl-left"]}]
     [:div {:class ["widget-rgl-header" "widget-rgl-right"]}]]))
